export const outsourceCompanyColumns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 110,
    renderCell: (params) => params.value,
  },
  {
    field: 'facilityName',
    headerName: 'Facility',
    flex: 1,
    minWidth: 110,
    renderCell: (params) => params.value,
  },
];
